import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, COMPANY_DETAILS, PUBLIC } from "../../common/URLs";

export const fetchCompanyDetails = async (uuid) => {
    const url = `${BASE_URL}/${PUBLIC}/${COMPANY_DETAILS}/${uuid}`; // Proxy path
    try {
      const token = await fetchToken()
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      // console.log("company detail api response", response)
      const data = await response.json();
      return data;
    } catch (error) {
      console.log("error", error);
    }
  };